module.exports = __webpack_public_path__ + "img/Account-Transaction-Gradient.8115081b.svg";